import { Tag } from "antd"
import { useTranslation } from "react-i18next"

import { CHANNEL_COLORS, channelLabel } from "../utils/vocabulary"

// The channel tag — tinted fill, coloured text and border — in the Analytics channel colours, so a
// channel reads the same in the tables as in the donut, the flow and the trends (RCA-8-02). Shared by
// the Receipt lookups table and its phone cards, Recent lookups, Lookup activity and the Repeat
// cardholders phone cards (CHA1-4949).
const ChannelTag = ({ value }) => {
  const { t } = useTranslation()
  const color = CHANNEL_COLORS[value]

  if (!color) return "—"

  return (
    <Tag style={{ margin: 0, color, background: `${color}14`, borderColor: `${color}4D` }}>
      {t(channelLabel(value))}
    </Tag>
  )
}

export default ChannelTag
